import { ChatStreamEvent } from './chat-stream-event.model';

export function parseSseEvents(partialText: string): ChatStreamEvent[] {
  if (!partialText) {
    return [];
  }

  const blocks = partialText.split('\n\n');
  // Drop the last block — it may be incomplete and will be re-parsed on the next progress event
  const completeBlocks = blocks.slice(0, -1);

  const events: ChatStreamEvent[] = [];

  for (const block of completeBlocks) {
    const lines = block.split('\n');
    for (const line of lines) {
      if (!line.startsWith('data:')) {
        continue;
      }
      const json = line.slice('data:'.length).trim();
      try {
        const parsed = JSON.parse(json);
        if (parsed && typeof parsed.type === 'string') {
          events.push(parsed as ChatStreamEvent);
        }
      } catch {
        // malformed JSON — skip
      }
    }
  }

  return events;
}
